import React, { ReactElement } from 'react'
import { Box, Chip, Typography } from '@mui/material'
import dayjs from 'dayjs'

type FieldComparisonProps = {
  label: string
  finalizedValue: string
  pendingValue: string | null
  isDate?: boolean
}

export let FieldComparison = ({
  label,
  finalizedValue,
  pendingValue,
  isDate = false,
}: FieldComparisonProps): ReactElement => {
  let hasChanged =
    !!pendingValue &&
    (isDate
      ? !dayjs(pendingValue).isSame(dayjs(finalizedValue), 'day')
      : pendingValue !== finalizedValue)

  let displayFinalizedValue = isDate
    ? finalizedValue
      ? dayjs(finalizedValue).format('MMM D, YYYY')
      : '—'
    : finalizedValue
  let displayPendingValue = pendingValue
    ? isDate
      ? dayjs(pendingValue).format('MMM D, YYYY')
      : pendingValue
    : '(unchanged)'

  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        color="text.secondary"
        variant="caption"
        sx={{
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <Box className="grid grid-cols-2 gap-4 mt-1">
        <Typography color="text.secondary" variant="body2">
          {displayFinalizedValue}
        </Typography>
        <Box className="flex items-center gap-2">
          <Typography
            variant="body2"
            sx={{
              color: hasChanged ? 'warning.main' : 'text.secondary',
              fontWeight: hasChanged ? 600 : 400,
            }}
          >
            {displayPendingValue}
          </Typography>
          {hasChanged && <Chip color="warning" label="Changed" size="small" />}
        </Box>
      </Box>
    </Box>
  )
}
